/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui';


/* ++++++++++ --------------- app.filters : STYLES --------------- ++++++++++ */
export default {
    status: {
      textTransform: 'capitalize',
      '&.pending': {
        background: '#E390001A',
        color: '#E39000',
        '& .circle': {
          background: '#E39000',
        }
      },
      '&.tested': {
        background: '#33AADD1A',
        color: '#33AADD',
        '& .circle': {
          background: '#33AADD',
        }
      },
      '&.live': {
        background: '#29CE001A',
        color: '#29CE00',
        '& .circle': {
          background: '#29CE00',
        }
      },
      '&.edited': {
        background: '#EB3D401A',
        color: '#EB3D40',
        '& .circle': {
          background: '#EB3D40',
        }
      },
      '& .circle': {
        width: pxToEm(14),
        height: pxToEm(14),
        borderRadius: pxToEm(14)
      },
      height: pxToEm(26),
      fontSize: pxToEm(12),
      padding: pxToEm(16),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: pxToEm(8),
      background: '#FCD639',
      color: '#000',
      borderRadius: pxToEm(24)
    }
};
